<template>
    <v-layout column align-center style="gap: 10px" v-if="!isUserEmployee">
        <template v-if="value.isSuccess === null">
            <template v-if="isUserEmployer">
                <reply-dialog
                    v-bind="{
                        value,
                        program,
                        isSuccess: true,
                        isUserEmployee,
                        isUserEmployer,
                    }"
                    v-on="{
                        input,
                    }"
                >
                    <template #activator="{ attrs, on }">
                        <v-btn small outlined width="73" color="primary" v-bind="attrs" v-on="on">
                            <span>채용</span>
                        </v-btn>
                    </template>
                </reply-dialog>
                <reply-dialog
                    v-bind="{
                        value,
                        program,
                        isSuccess: false,
                        isUserEmployee,
                        isUserEmployer,
                    }"
                    v-on="{
                        input,
                    }"
                >
                    <template #activator="{ attrs, on }">
                        <v-btn small outlined width="73" color="grey-d" v-bind="attrs" v-on="on">
                            <span class="grey--text">미채용</span>
                        </v-btn>
                    </template>
                </reply-dialog>
            </template>
            <template v-else>
                <v-btn small width="73" color="primary lighten-5">
                    <span class="primary--text">면접예정</span>
                </v-btn>
            </template>
        </template>
        <template v-if="value.isSuccess === true">
            <reply-employ v-bind="{ value }">
                <template #activator="{ attrs, on }">
                    <template v-if="isUserEmployer">
                        <v-btn small width="73" color="primary lighten-5" v-bind="attrs" v-on="on">
                            <span class="primary--text">채용</span>
                        </v-btn>
                    </template>
                    <template v-else>
                        <v-btn small width="73" color="secondary lighten-5" v-bind="attrs" v-on="on">
                            <span class="secondary--text">채용완료</span>
                        </v-btn>
                    </template>
                </template>
            </reply-employ>
        </template>
        <template v-if="value.isSuccess === false">
            <v-btn small width="73" color="grey lighten-5">
                <span class="grey--text">미채용</span>
            </v-btn>
        </template>
    </v-layout>
</template>

<script>
import { initExpoMatching, initExpoProgram } from "@/assets/variables/inits";

import ReplyDialog from "./reply/reply-dialog.vue";
import ReplyEmploy from "./reply/reply-employ.vue";

export default {
    components: {
        ReplyDialog,
        ReplyEmploy,
    },
    props: {
        value: { type: Object, default: initExpoMatching },
        program: { type: Object, default: initExpoProgram },
        isUserHost: { type: Boolean, default: false },
        isUserEmployee: { type: Boolean, default: false },
        isUserEmployer: { type: Boolean, default: false },
    },
    methods: {
        input(matching) {
            this.$emit("input", matching);
        },
    },
};
</script>

<style>
</style>